import {
  observable,
  action
} from 'mobx'
import {store} from '../store.index';
import axios from "axios";

class openUrlFile {
  // @observable isLogin = false;
  @observable showURLInputDialog = false
  @observable showURLFailDialog = false

  @action openURLInputDialog(val) {
    console.log(val)
    this.showURLInputDialog = val
  }
  @action isShowURLFailDialog(val) {
    this.showURLFailDialog = val
  }
  @action openUrlFile(val, fileName) {
    this.openURLInputDialog(false)
    store.common.setIsShowMeeting(true) 
    var formurl = window.decodeURIComponent(val)
    fileName = fileName || formurl.split("/")[formurl.split("/").length - 1]
    let headers = {}
    if(store.loginNewStore.IAMToken) {
      headers.Authorization = `Bearer ${store.loginNewStore.IAMToken}`
      // if(formurl.includes("&token=")) {
      //   let urlArr = formurl.split("&token=")
      //   formurl = urlArr[0] + "&oldToken=" + urlArr[1]
      // }
    }
    // let config = {
    //   headers: {
    //     ...headers,
    //     'caches': false,
    //     'responseType': 'multipart/form-data',
    //     withCredentials: true,
    //   },
    // }
    // axios.get(formurl, config)
    axios({
      url: formurl,
      method: 'get',
      caches: false,
      responseType: 'multipart/form-data',
      withCredentials: true,
      headers
    })
    .then(response => {
      console.log(response)
      var fileType = response.toString().slice(1, 4)
      if (fileType === "PDF") {
        this.getFromRemote(formurl, 'blob',(buffer) => {
          store.common.setIsShowMeeting(false) 
          // TODO FOXIT 删除参数中的password
          window.pdfui.openPDFByFile(buffer, { fileName: fileName || "untitle.pdf" });
        })
      } else {
        store.common.setIsShowMeeting(false)
        this.getFromRemote(formurl, 'blob',(buffer) => {
          // 若满足装换格式，文件走转换逻辑后打开
          if(buffer.type.match("image") || store.convert.MIMEType.includes(buffer.type)) {
            let fileName = "untitle.png"
            if(buffer.type === 'application/msword' || buffer.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
              fileName = "untitle.doc"
            } else if (buffer.type === 'application/vnd.ms-excel' || buffer.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
              fileName = "untitle.xls"
            } else if (buffer.type === 'application/vnd.ms-powerpoint' || buffer.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || buffer.type === 'application/vnd.openxmlformats-officedocument.presentationml.slideshow') {
              fileName = "untitle.ppt"
            }
            store.convert.openFileBeforeConvert(buffer, fileName);
          }
        })
        // 打开远程文件非pdf格式，需要调用转换接口转pdf文件后打开
        
      }
    }).catch(() => {
      store.common.setIsShowMeeting(false) 
      this.isShowURLFailDialog(true)
    })
  }
  @action getFromRemote(url, type ,callback) {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true
    if(store.loginNewStore.IAMToken) {
      xhr.headers = {
        "Authorization": store.loginNewStore.IAMToken
      }
    }
    xhr.onreadystatechange = function()  {
        var status = xhr.status;
        if (xhr.readyState === XMLHttpRequest.DONE || xhr.readyState == 4) {
            if (status >= 200 && status < 300 || status === 304) {
                if (type === 'json' && typeof xhr.response === 'string') {
                    callback(JSON.parse(xhr.response))
                } else {
                    callback(xhr.response)
                }
            } else {
              console.log('getFromRemote 3')
                callback(xhr.response)
            }
        }
    };
    xhr.onerror = function(ev) {
        callback(ev)
    };
    xhr.open('GET', url, true);
    if(store.loginNewStore.IAMToken) {
      xhr.setRequestHeader("Authorization",`Bearer ${store.loginNewStore.IAMToken}`);
    }
    xhr.responseType = type;
    xhr.send();
}
}


export default openUrlFile;
